export const ErrorCodes = {
  FORBIDDEN_REQUEST: 'MER-PAY-1000',
  REFERENCE_SPECIAL_CHARACTERS: 'MER-PAY-2009',
  CRYPTO_ADDRESS_INVALID_FOR_WHITELISTING: 'MER-XP-2001',
  CRYPTO_ADDRESS_ALREADY_WHITELISTED: 'MER-XP-2002',
  INVALID_ADDRESS: 'MER-PAY-2027',
  FAILED_FINCRIME_INVALID_ADDRESS: 'MER-PAY-2028',
  BENEFICIARY_MANAGEMENT_ERROR: 'BEN-MAN-001',
}
